<template>
  <b-alert show>
    <div>{{ $dt('global.route_deprecated', 'Route moved. Please contact administrator') }}</div>
    <div v-if="newUrl">{{ $dt('global.new_route', 'New address:') + ' ' + newUrl }}</div>
  </b-alert>
</template>
<script>
export default {
  name: 'DeprecatedRoute',
  props: {
    url: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      default: null,
    },
  },

  computed: {
    newUrl() {
      if (this.url && this.params) {
        return window.location.origin + this.url.replace(/:([0-9a-zA-Z_-]+)/g, (match, p1) => {
          return this.params[p1];
        });
      }
      else if (this.url) {
        return window.location.origin + this.url;
      }
      else {
        return "";
      }
    },
  },
};
</script>